import { OpenLRLastLocationReferencePoint } from './openlrlastlocationreferencepoint.model';
import { OpenLRLocationReferencePoint } from './openlrlocationreferencepoint.model';
import { OpenLROffsets } from './openlroffsets.model';

export class FirstDirection {
  openlrLastLocationReferencePoint: OpenLRLastLocationReferencePoint;
  openlrLocationReferencePoint: OpenLRLocationReferencePoint[];
  openlrOffsets: OpenLROffsets;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/firstdirection.model.ts